// /src/hooks/useEmailRecuperation.js

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  swalConfirmationAlert,
  swalAlertDanger,
  swalAlertSuccess,
  swalAlertInfo,
} from "../../../components/common/Alerts";
import emailRecuperationService from "../services/emailRecuperation.service";

const useEmailRecuperation = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");

  const handleVerifyEmail = async (data) => {
    try {
      const res = await emailRecuperationService.verifyEmail(data);
      if (res.status === 200) {
        swalConfirmationAlert(
          "CORREO ENCONTRADO",
          `Será enviado un código de recuperación a ${data.email} para poder cambiar su contraseña`,
          () => {
            setEmail(data.email);
            setStep(2);
          }
        );
      } else if (res.status === 203) {
        swalAlertInfo(
          "El email ingresado no pertenece a ningún usuario del sistema",
          "Verifique los datos y vuelva a intentar nuevamente",
          () => {}
        );
      } else {
        swalAlertDanger(
          "Error al enviar el código",
          "Inténtelo nuevamente más tarde",
          () => {
            navigate("/");
          }
        );
      }
    } catch (error) {
      console.log(error);
      swalAlertDanger(
        "Error al enviar el código",
        "Inténtelo nuevamente más tarde",
        () => {
          navigate("/");
        }
      );
    }
  };

  const handleVerifyCode = async (recovery_code) => {
    try {
      const res = await emailRecuperationService.verifyCode(
        recovery_code,
        email
      );
      if (res.status === 200) {
        swalAlertSuccess(
          "CÓDIGO DE RECUPERACIÓN CORRECTO",
          "Será redireccionado para poder cambiar su contraseña",
          () => {
            setStep(3);
          }
        );
      } else if (res.status === 203) {
        swalAlertInfo(
          "Código de recuperación incorrecto, inténtelo nuevamente",
          "",
          () => {}
        );
      } else {
        swalAlertDanger(
          "Error al enviar el código",
          "Inténtelo nuevamente más tarde",
          () => {
            navigate("/");
          }
        );
      }
    } catch (error) {
      console.log(error);
      swalAlertDanger(
        "Error al enviar el código",
        "Inténtelo nuevamente más tarde",
        () => {
          navigate("/");
        }
      );
    }
  };

  const handleChangePassword = async (newPassword) => {
    try {
      const res = await emailRecuperationService.changePassword(
        newPassword,
        email
      );
      if (res.status === 200) {
        swalAlertSuccess(
          "CONTRASEÑA GENERADA CON ÉXITO",
          "Inicie sesión con su nueva clave",
          () => {
            navigate("/");
          }
        );
      } else {
        swalAlertDanger(
          "Error al procesar la solicitud de cambio de clave",
          "Inténtelo nuevamente más tarde",
          () => {
            navigate("/");
          }
        );
      }
    } catch (error) {
      console.log(error);
      swalAlertDanger(
        "Error al enviar el código",
        "Inténtelo nuevamente más tarde",
        () => {
          navigate("/");
        }
      );
    }
  };

  return {
    step,
    email,
    handleVerifyEmail,
    handleVerifyCode,
    handleChangePassword,
  };
};

export default useEmailRecuperation;
